
import storage from './storage'

const install = function (Vue) {
  Vue.prototype.$storage = storage
};
export default install;



// WEBPACK FOOTER //
// ./src/storage/index.js